import { fr, type TextKey } from '../content/fr';

export type TextParams = Record<string, string | number>;

/** Renvoie le texte d'une clé, en remplaçant les {paramètres}. */
export function t(key: TextKey, params?: TextParams): string {
  const template: string = fr[key];
  if (!params) return template;
  return template.replace(/\{(\w+)\}/g, (match, name: string) =>
    name in params ? String(params[name]) : match,
  );
}
